import React from 'react';
import { Instagram, Linkedin, Youtube, Facebook, Mail, Phone, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { footerData } from '../data/mock';

const iconMap = {
  Instagram: Instagram,
  Linkedin: Linkedin,
  Youtube: Youtube,
  Facebook: Facebook
};

const Footer = () => {
  return (
    <footer id="contact" className="bg-slate-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <h3 className="text-3xl font-bold bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent">
                KISAT Media
              </h3>
              <p className="text-slate-400 mt-4 leading-relaxed">
                {footerData.about}
              </p>
            </div>

            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <a
                href={`mailto:${footerData.contact.email}`}
                className="flex items-center gap-3 text-slate-300 hover:text-red-400 transition-colors group"
              >
                <div className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors">
                  <Mail className="w-5 h-5" />
                </div>
                <span>{footerData.contact.email}</span>
              </a>
              <a
                href={`tel:${footerData.contact.phone}`}
                className="flex items-center gap-3 text-slate-300 hover:text-red-400 transition-colors group"
              >
                <div className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors">
                  <Phone className="w-5 h-5" />
                </div>
                <span>{footerData.contact.phone}</span>
              </a>
            </div>

            {/* Social Links */}
            <div className="flex gap-3">
              {footerData.social.map((social) => {
                const IconComponent = iconMap[social.icon];
                return (
                  <a
                    key={social.platform}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-lg bg-slate-800 hover:bg-gradient-to-br hover:from-red-600 hover:to-red-700 flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-red-500/30"
                    aria-label={social.platform}
                  >
                    <IconComponent className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Sections */}
          {footerData.sections.map((section, index) => (
            <div key={index}>
              <h4 className="text-lg font-bold text-white mb-6">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-slate-400 hover:text-cyan-400 transition-colors flex items-center gap-2 group"
                    >
                      <ArrowRight className="w-4 h-4 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" />
                      <span>{link.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-400">
            <p>
              © {new Date().getFullYear()} KISAT Media. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#privacy" className="hover:text-red-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#terms" className="hover:text-red-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
